if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        dotsContainer: this.querySelector('[id^="GalleryDots"]')  // 新增：dots 容器
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      //点击dot切换
       this.elements.dotsContainer.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

   
    // 更新小圆点的状态
    onSlideChanged(event) {
      
      if (event.detail.currentElement == undefined) return;
  
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);

      const dot = this.elements.dotsContainer.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);  // 通过 data-target 找到对应的小圆点
      this.setActiveDot(dot);  // 设置当前小圆点为激活状态
     
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
   
      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

      if (!this.elements.dotsContainer) return;
      const activeDot = this.elements.dotsContainer.querySelector(`[data-target="${mediaId}"]`);  // 通过 data-target 查找对应的小圆点
      this.setActiveDot(activeDot);  // 设置当前小圆点为激活状态
  

      
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
    }
    
   setActiveDot(dot) {
    if (!this.elements.dotsContainer || !dot) return;

      // 移除所有小圆点的激活状态
      this.elements.dotsContainer.querySelectorAll('.media-gallery-dot').forEach((element) => {
        element.classList.remove('is-active');
      });

      // 设置当前小圆点为激活状态
      dot.classList.add('is-active');

     // 调整可见的小圆点范围
      const dots = Array.from(this.elements.dotsContainer.querySelectorAll('.media-gallery-dot'));
      const activeIndex = dots.indexOf(dot);

      // 计算当前激活的圆点的前后四个
      this.setVisibleDots(activeIndex);
     
    }

    // 调整可见的圆点范围，只显示激活的圆点及其左右4个
    setVisibleDots(activeIndex) {
      const dots = this.elements.dotsContainer.querySelectorAll('.media-gallery-dot');
      const totalDots = dots.length;
      
      // 确定可见的圆点范围
      const startIndex = Math.max(0, activeIndex - 4); // 左侧最多显示4个圆点
      const endIndex = Math.min(totalDots - 1, activeIndex + 4); // 右侧最多显示4个圆点

      // 设置所有圆点的显示或隐藏
      dots.forEach((dot, index) => {
        if (index >= startIndex && index <= endIndex) {
          dot.style.display = 'inline-block'; // 显示
        } else {
          dot.style.display = 'none'; // 隐藏
        }
      });

      // 滚动到当前激活的圆点
      const offset = (activeIndex - startIndex) * (dots[0].offsetWidth + 10); // 假设圆点之间的间距为 10px
      this.elements.dotsContainer.scrollTo({ left: offset, behavior: 'smooth' });
    }

    

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
